import type {Money} from "../../../../lib/Money.ts";
import type {Subledger} from "../../SubledgerSelector";
import type {AxisIds} from "./utils/groupingAxis.ts";
import type {PresentationSourceType} from "../../../../generated/enums.ts";

export interface JournalLeg {
    accountCode: string;
    accountLabel: string;
    description: string | null;
    debit: Money | null;
    credit: Money | null;
    isCurrentAccount: boolean;
}

export interface PanelBooking {
    key: string;
    kind: PresentationSourceType | null;
    title: string;
    subtitle: string | null;
    relationName: string | null;
    invoiceNumber: string | null;
    fileName: string | null;
    date: string | null;
    documentId: string | null;
    transactionId: string | null;
    manualBookingId: string | null;
    billId: string | null;
    axisIds: AxisIds;
    billLineItemId: string | null;
    debit: Money;
    credit: Money;
    legs: JournalLeg[];
    legsAreBalanced: boolean;
    selectable: boolean;
    notSelectableReason: string | null;
    subledger: Subledger | null;
    vatLabel: string | null;
}

export enum BookingSortColumn {
    Date = "date",
    Debit = "debit",
    Credit = "credit",
}

export interface BookingSort {
    column: BookingSortColumn;
    ascending: boolean;
}

export enum BookingFilter {
    All = "all",
    Transactions = "transactions",
    Bills = "bills",
    ManualBookings = "manual_bookings",
    FixedAssets = "fixed_assets",
    Matches = "matches",
    CounterNature = "counter_nature",
}

export enum AccountNature {
    Debit = "debit",
    Credit = "credit",
}

export interface BookingFilterCounts {
    all: number;
    transactions: number;
    bills: number;
    manualBookings: number;
    fixedAssets: number;
    matches: number;
    counterNature: number;
}

export interface PanelTotals {
    debit: Money;
    credit: Money;
    saldo: Money;
}
